import React from 'react';
import connect from 'react-redux/es/connect/connect';
import { Box } from '@material-ui/core';
import StepperComp from '../entryForm/stepper/EntryStepper';
import urls from '../../../../constants/urls';
import MainBody from '../../../../components/templates/mainBody/MainBody';
import BasicBreadcrumbs from '../../../../components/organisms/basicBreadcrumbs/BasicBreadcrumbs';
import ContractForm from '../entryForm/contract/ContractForm';
import UserForm from '../entryForm/user/UserForm';
import ConfirmForm from '../entryForm/confirm/ConfirmForm';
import PasswordForm from '../entryForm/password/PasswordForm';
import CompleteEntry from '../entryForm/complete/CompleteEntry';
import { createForm } from '../entryForm/entry-proc';
import { actCallApiInitSelectValues, actCallSetMemberEntryForm } from '../../../../redux/member/entry/action';

class CorporationEntry extends React.Component {
  constructor(props) {
    super(props);

    this.breadcrumbs = [
      { url: urls.MEMBER.MEMBER_LIST, name: '会員' },
      { name: '法人会員登録' },
    ];
    const initSelectValues = {
      prefexturesSelectList: [],
      storesSelectList: [],
      contractCodeSelectList: [],
      genderSelectList: [],
      applicantTypeSelectList: [],
      membershipAgreementSelectList: [],
    };
    props.dispatch(actCallApiInitSelectValues());

    this.state = {
      activeStep: 0,
      initSelectValues,
      isCorporation: true,
      isFromConfirmForm: false,
      saveDatas: {},
    };

    this.scrollToTop();
    this.props.dispatch(actCallSetMemberEntryForm(createForm()));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.entry.initSelectValues !== this.props.entry.initSelectValues) {
      if (this.props.entry.initSelectValues) {
        this.setInitSelectValues(this.props.entry.initSelectValues);
      }
    }
    if (prevProps.entry.isSaveSuccess !== this.props.entry.isSaveSuccess) {
      if (this.props.entry.isSaveSuccess) {
        this.setComplete(this.props.entry.saveMembers);
      }
    }
  }

  setComplete = (saveDatas) => {
    this.scrollToTop();
    this.setState({ saveDatas, activeStep: 4 });
  }

  setInitSelectValues = (initSelectValues) => {
    this.setState({ initSelectValues });
  }

  scrollToTop = () => window.scrollTo(0, 0);

  onClickToNext = (activeStep) => {
    this.scrollToTop();
    this.setState({ activeStep });
  }

  onClickGoBackFromConfirm = (activeStep, isFromConfirmForm) => {
    this.scrollToTop();
    this.setState({ activeStep, isFromConfirmForm });
  }

  render() {
    const {
      activeStep,
      isCorporation,
      isFromConfirmForm,
      initSelectValues,
      saveDatas,
    } = this.state;

    return (
      <div>
        <BasicBreadcrumbs breadcrumbs={this.breadcrumbs} />
        <MainBody>
          <StepperComp activeStep={activeStep} />

          <Box display={activeStep === 0 ? '' : 'none'}>
            <ContractForm
              isCorporation={isCorporation}
              onClickToNext={this.onClickToNext}
              initSelectValues={initSelectValues}
            />
          </Box>

          <Box display={activeStep === 1 ? '' : 'none'}>
            <UserForm
              isCorporation={isCorporation}
              isFromConfirmForm={isFromConfirmForm}
              onClickToNext={this.onClickToNext}
              initSelectValues={initSelectValues}
            />
          </Box>

          <Box display={activeStep === 2 ? '' : 'none'}>
            <PasswordForm
              onClickToNext={this.onClickToNext}
            />
          </Box>

          <Box display={activeStep === 3 ? '' : 'none'}>
            <ConfirmForm
              onClickGoBackFromConfirm={this.onClickGoBackFromConfirm}
              initSelectValues={initSelectValues}
              isSameContractUser="1"
            />
          </Box>

          <Box display={activeStep === 4 ? '' : 'none'}>
            <CompleteEntry datas={saveDatas} />
          </Box>
        </MainBody>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({ entry: state.entry });

export default connect(mapStateToProps)(CorporationEntry);
